import { render, staticRenderFns } from "./Live.vue?vue&type=template&id=17efe3b4&scoped=true&"
import script from "./Live.vue?vue&type=script&lang=ts&"
export * from "./Live.vue?vue&type=script&lang=ts&"
import style0 from "./Live.vue?vue&type=style&index=0&id=17efe3b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17efe3b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17efe3b4')) {
      api.createRecord('17efe3b4', component.options)
    } else {
      api.reload('17efe3b4', component.options)
    }
    module.hot.accept("./Live.vue?vue&type=template&id=17efe3b4&scoped=true&", function () {
      api.rerender('17efe3b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Live.vue"
export default component.exports